<script>
    export let icon;
    export let size = 20;
    export let color = 'currentColor';
</script>

<img src="https://icongr.am/entypo/{ icon }.svg?size={ size }&color={ color }"/>